import { cx } from '@emotion/css';
import { getHintColor, getHintIcon, getHintRole } from './hint-utils';
import { HintProps } from './hint.types';

export const Hint = ({ type, message, dataTestId, className, labelClassName }: HintProps) => {
  return (
    <div className={cx('mt-xs flex flex-row space-x-2', className)} data-testid={dataTestId} aria-live="polite">
      <svg className={cx('h-4 w-4', getHintColor(type))}>
        <use xlinkHref={getHintIcon(type) + '#img'} />
      </svg>
      <span className={cx('flex-1 stihl-text-body-sm-reg', labelClassName)} role={getHintRole(type)}>
        {message as string}
      </span>
    </div>
  );
};
